<template>
  <AuthPageContainer>
    <template #header>
      {{ $t("confirm_register.title") }}
    </template>

    <div class="gap-row-sm w-100">
      <div class="w-100 gap-row-1xs" v-if="missing_fields.includes('address')">
        <div class="w-100 qrw-label-sm bold v1-grey-6-color">
          {{ $t('register.address_ph') }}
        </div>
        <BaseInput
          :value="form.address"
          placeholder=" "
          :valid="validation.address"
          inputId="gmapField"
          fullWidth
        />
      </div>
      <div class="w-100 gap-row-1xs">
        <div class="w-100 qrw-label-sm bold v1-grey-6-color">
          {{ $t("confirm_register.create_password") }}
        </div>
        <BaseInput
          type="password"
          :valid="!error"
          v-model="form.password"
          fullWidth
        />
      </div>
      <div class="w-100 gap-row-1xs">
        <div class="w-100 qrw-label-sm bold v1-grey-6-color">
          {{ $t("confirm_register.repeat_password") }}
        </div>
        <BaseInput
          type="password"
          :valid="!error"
          v-model="form.repeat"
          fullWidth
        />
      </div>
      <PasswordMeter
        :value="form.password"
        @score="(v) => (last_password_score = v)"
      />
      <div class="red-4-color qrw-input-text" v-if="error">
        {{ error }}
      </div>
    </div>

    <div class="gap-row-sm w-100">
      <BaseDivider color="v1-grey-4" />
      <BaseButton
        variant="primary"
        size="lg"
        color="green-5"
        :disabled="!isFormValid || busy"
        @click="onConfirmRegistration"
      >
        {{ $t("confirm_register.create_acccount") }}
      </BaseButton>
    </div>
  </AuthPageContainer>
</template>

<script>
import AuthPageContainer from "@/components/AuthPageContainer";
import PasswordMeter from "@/components/PasswordMeter.vue";

import GoogleMapsService from "@/services/googlemaps"

import JoinAPI from "@/api/join";

export default {
  components: {
    AuthPageContainer,
    PasswordMeter,
  },
  watch: {
    "form.password"() {
      this.error = null;
    },
  },
  data() {
    return {
      form: {
        password: null,
        repeat: null,
        city: null,
        country: null,
        language: null,
        address: null,
        address_location: null,
        role: null,
      },

      last_password_score: 0,

      autocomplete_object: null,

      busy: false,

      error: null,

      missing_fields: [],

      validation: {
        address: true
      }
    };
  },
  methods: {
    sendForm() {},
    checkRegisterKey() {
      JoinAPI.check(this.register_key)
        .then((data) => {
          this.missing_fields = data.missing_fields;

          if (this.missing_fields.includes("address")) {
            setTimeout(() => {
              this.$nextTick(this.initAddressField);
            }, 750);
          }
        })
        .catch(() => {
          this.$router.push("/register");
        });
    },
    initAddressField() {
      const element = document.getElementById("gmapField");

      this.autocomplete_object = GoogleMapsService.initAutocompleteWidget(
        element,
        this.onPlaceChanged
      );
    },
    onPlaceChanged() {
      const result = GoogleMapsService.decodeAutocompletePlace(
        this.autocomplete_object
      );

      this.form.address = result.address;
      this.form.city = result.city;
      this.form.address_location = result.location;
      this.form.country = result.country;
    },
    onConfirmRegistration() {
      if (this.busy) return;

      if (this.last_password_score < 2) {
        this.error = this.$t("confirm_register.errors.weak");
        return;
      }

      if (this.form.password != this.form.repeat) {
        this.error = this.$t("confirm_register.errors.mismatch");
        return;
      }

      if (this.missing_fields.includes("address") && !this.form.address) {
        this.validation.address = false;
        return;
      }

      this.busy = true;

      JoinAPI.confirm(this.register_key, {
        password: this.form.password,
        address: this.form.address,
        address_location: this.form.address_location,
        city: this.form.city,
        country: this.form.country,
        role: this.form.role,
      })
        .then(() => {
          window.location.href = "https://dashboard.qrwaiter.com.ua";
          this.busy = false;
        })
        .catch(() => {
          this.error = "Не вдалось створити аккаунт.";
          this.busy = false;
        });
    },
  },
  mounted() {
    this.checkRegisterKey();
  },
  computed: {
    isFormValid() {
      return this.form.password && this.form.repeat;
    },
    register_key() {
      return this.$route.params.id;
    },
  },
};
</script>

<style>
</style>